import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaWhatsapp,
  FaFilter,
  FaCalendarCheck,
  FaBullhorn,
  FaChartLine,
  FaExchangeAlt,
  FaCalendarAlt,
  FaIdCard,
  FaChalkboardTeacher,
  FaFileInvoiceDollar,
  FaChartBar,
  FaSitemap,
} from 'react-icons/fa';
import converleadLogo from '../assets/logos/converlead.png';
import axysLogo from '../assets/logos/axys.png';
import './ServicesSection.css';

const converleadModules = [
  { Icon: FaFilter, title: 'Funil comercial', text: 'Do novo contato à conversão, com aula agendada, realizada ou falta.' },
  { Icon: FaWhatsapp, title: 'WhatsApp no dia a dia', text: 'Leads entram organizados e o histórico da conversa fica no mesmo lugar.' },
  { Icon: FaCalendarCheck, title: 'Agenda de experimentais', text: 'Marque a aula, acompanhe comparecimento e envie lembretes no horário da unidade.' },
  { Icon: FaBullhorn, title: 'Campanhas e automações', text: 'Follow-ups por status e origem, com mensagens prontas ou apoio de IA.' },
  { Icon: FaChartLine, title: 'Indicadores e relatórios', text: 'Funil, origens e planos mais vendidos para decidir com dados.' },
  { Icon: FaExchangeAlt, title: 'Integração com AXYS', text: 'Na conversão, o cadastro segue para o módulo operacional do Studio.' },
];

const axysModules = [
  { Icon: FaCalendarAlt, title: 'Agenda e turmas', text: 'Aulas, capacidade, feriados, faltas e reposições pendentes.' },
  { Icon: FaIdCard, title: 'Alunos e matrículas', text: 'Cadastro, renovação, planos e contratos da unidade.' },
  { Icon: FaChalkboardTeacher, title: 'Profissionais', text: 'Quem dá aula, em qual grade e com qual ocupação.' },
  { Icon: FaFileInvoiceDollar, title: 'Financeiro', text: 'Lançamentos, visão mensal e comissões da equipe.' },
  { Icon: FaChartBar, title: 'Relatórios da operação', text: 'Ocupação e resultado da unidade em um só painel.' },
  { Icon: FaSitemap, title: 'Várias unidades', text: 'Troca de unidade, permissões e visão da rede.' },
];

const ServicesSection = () => (
  <section className="services-section" id="solutions">
    <div className="container">
      <p className="services-kicker">Ecossistema Convertrex</p>
      <h2 className="section-title">Dois módulos. Um único ecossistema.</h2>
      <p className="section-subtitle">
        A Convertrex conecta comercial e operação. Converlead e AXYS são módulos desse ecossistema —
        feitos para funcionar sozinhos ou juntos.
      </p>

      <article className="product-panel" id="converlead">
        <div className="product-copy">
          <span className="product-tag">Módulo comercial</span>
          <div className="product-brand">
            <img src={converleadLogo} alt="" className="product-logo product-logo--mark" />
            <h3>Converlead</h3>
          </div>
          <p className="product-lead">
            Organize o funil do primeiro WhatsApp até a matrícula. A equipe vê origem, histórico,
            experimental e conversão sem perder follow-up.
          </p>
        </div>
        <ul className="product-modules">
          {converleadModules.map(({ Icon, title, text }) => (
            <li key={title}>
              <div className="module-icon" aria-hidden="true">
                <Icon size={24} />
              </div>
              <div>
                <strong>{title}</strong>
                <span>{text}</span>
              </div>
            </li>
          ))}
        </ul>
      </article>

      <article className="product-panel product-panel--axys" id="axys">
        <div className="product-copy">
          <span className="product-tag product-tag--green">Módulo operacional</span>
          <div className="product-brand">
            <img src={axysLogo} alt="AXYS" className="product-logo product-logo--wordmark" />
          </div>
          <p className="product-lead">
            A rotina do Studio em um só lugar: agenda, alunos, planos, financeiro e gestão de
            unidades.
          </p>
        </div>
        <ul className="product-modules">
          {axysModules.map(({ Icon, title, text }) => (
            <li key={title}>
              <div className="module-icon module-icon--green" aria-hidden="true">
                <Icon size={24} />
              </div>
              <div>
                <strong>{title}</strong>
                <span>{text}</span>
              </div>
            </li>
          ))}
        </ul>
      </article>

      <article className="web-strip">
        <div>
          <span className="product-tag product-tag--light">Presença digital</span>
          <h3>Desenvolvimento web</h3>
          <p>
            Sites modernos e rápidos para o Studio aparecer bem — e receber o lead no mesmo
            ecossistema Convertrex.
          </p>
        </div>
        <ul>
          <li>Layout responsivo</li>
          <li>Otimização para busca</li>
          <li>Alta performance</li>
          <li>Identidade da marca</li>
        </ul>
      </article>

      <div className="ecosystem-cta">
        <p>Escolha o plano do ecossistema Convertrex para o momento do seu Studio.</p>
        <Link to="/planos" className="product-cta">
          Ver planos
        </Link>
      </div>
    </div>
  </section>
);

export default ServicesSection;
